"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Enforcer = void 0;
var _createForOfIteratorHelper2 = _interopRequireDefault(require("@babel/runtime/helpers/createForOfIteratorHelper"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _utility = require("./utility");
var Enforcer = exports.Enforcer = /*#__PURE__*/function () {
  function Enforcer() {
    (0, _classCallCheck2.default)(this, Enforcer);
  }
  (0, _createClass2.default)(Enforcer, null, [{
    key: "check",
    value: function check(context) {
      // -
      var allowed = false;
      // -
      var _iterator = (0, _createForOfIteratorHelper2.default)(context.policies),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var policy = _step.value;
          var _iterator2 = (0, _createForOfIteratorHelper2.default)(policy.Statement),
            _step2;
          try {
            var _loop = function _loop() {
                var statement = _step2.value;
                // 检查声明的效果
                var matched = context.request.resource.map(function (resource) {
                  return _utility.EnforcerUtility.isChipMatch(resource, statement.Resource);
                }).concat(_utility.EnforcerUtility.isChipMatch(context.request.action, statement.Action)).reduce(function (previousValue, currentValue) {
                  return previousValue && currentValue;
                }, true);
                // -
                if (matched) {
                  if (statement.Effect === 'Allow') {
                    allowed = true;
                  } else if (statement.Effect === 'Deny') {
                    // 拒绝优先 | 快速失败策略
                    return {
                      v: 'ExplicitDeny'
                    };
                  } else {
                    throw new TypeError("The effect ".concat(statement.Effect, " is currently not supported."));
                  }
                }
              },
              _ret;
            for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
              _ret = _loop();
              if (_ret) return _ret.v;
            }
          } catch (err) {
            _iterator2.e(err);
          } finally {
            _iterator2.f();
          }
        }
        // 如果没有匹配的声明，则默认隐式拒绝
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      return allowed ? 'Allow' : 'ImplicitDeny';
    }
  }]);
  return Enforcer;
}();